const headerLinks = [
  {
    key: "overview",
    link: "/2025",
    label: "Overview",
  },
  {
    key: "keynote",
    link: "/2025/keynote",
    label: "Keynote Speaker",
  },
  {
    key: "thread1",
    link: "/2025/thread-1",
    label: "Thread 1",
  },
  {
    key: "thread2",
    link: "/2025/thread-2",
    label: "Thread 2",
  },
  {
    key: "poster",
    link: "/2025/poster-gallery",
    label: "Poster Gallery",
  },
  {
    key: "team",
    link: "/2025/team",
    label: "The Team",
  },
];

export default headerLinks;
